export enum PaymentMethod {
  /** Chưa thanh toán */
  None = 0,

  /** Thanh toán trực tuyến */
  OnlinePayment = 1,

  /** Cửa hàng tiện lợi 24h */
  GroceryStore = 2,

  /** QR Code/ VN pay */
  QRCodeVNPay = 3,

  /** Thanh toán tại văn phòng */
  Cash = 4,

  /** Chuyển khoản Ngân hàng */
  InternetBanking = 5,

  /** Chờ Chuyên Viên tư vấn */
  CSO = 6,
}
